// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3VkjI","header":"PatientQuestionnaire_header__35Rmm","info":"PatientQuestionnaire_info__2QGt5"};